var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuppyFeatureAstrology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.60417 1.9125C9.64069 1.83872 9.6971 1.77661 9.76704 1.73319C9.83699 1.68977 9.91767 1.66676 10 1.66676C10.0823 1.66676 10.163 1.68977 10.233 1.73319C10.3029 1.77661 10.3593 1.83872 10.3958 1.9125L12.3208 5.81167C12.4476 6.06831 12.6348 6.29034 12.8664 6.45871C13.0979 6.62708 13.3668 6.73676 13.65 6.77833L17.955 7.40833C18.0366 7.42015 18.1132 7.45456 18.1762 7.50767C18.2393 7.56077 18.2862 7.63046 18.3117 7.70884C18.3372 7.78722 18.3402 7.87117 18.3205 7.9512C18.3008 8.03122 18.259 8.10413 18.2 8.16167L15.0867 11.1933C14.8813 11.3934 14.7277 11.6404 14.639 11.913C14.5503 12.1856 14.5292 12.4757 14.5775 12.7583L15.3125 17.0417C15.3269 17.1232 15.3181 17.2071 15.2871 17.2839C15.2561 17.3607 15.2041 17.4272 15.1371 17.4758C15.0701 17.5245 14.9908 17.5533 14.9082 17.5591C14.8256 17.5648 14.7431 17.5472 14.67 17.5083L10.8217 15.485C10.5681 15.3519 10.286 15.2823 9.99958 15.2823C9.71318 15.2823 9.43107 15.3519 9.1775 15.485L5.33 17.5083C5.25694 17.547 5.1745 17.5644 5.09204 17.5585C5.00959 17.5527 4.93043 17.5238 4.86358 17.4752C4.79673 17.4266 4.74486 17.3602 4.71388 17.2835C4.6829 17.2069 4.67405 17.1231 4.68833 17.0417L5.4225 12.7592C5.471 12.4764 5.44999 12.1862 5.36128 11.9134C5.27258 11.6406 5.11884 11.3935 4.91333 11.1933L1.8 8.1625C1.7405 8.10503 1.69833 8.032 1.6783 7.95173C1.65828 7.87146 1.6612 7.78718 1.68673 7.70849C1.71227 7.6298 1.75939 7.55987 1.82273 7.50665C1.88607 7.45344 1.96309 7.41908 2.045 7.4075L6.34917 6.77833C6.63271 6.73708 6.90199 6.62755 7.13382 6.45916C7.36565 6.29076 7.55309 6.06856 7.68 5.81167L9.60417 1.9125Z",
    stroke: "var(--stroke-0, #9AA78F)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuppyFeatureAstrology);
export default __webpack_public_path__ + "static/media/puppy-feature-astrology.0ee1f6ddade27062f16b21f4c3db143d.svg";
export { ForwardRef as ReactComponent };